export default "__VITE_ASSET__B6BI_tAA__"